import { useGlobalStacks } from "@/state/globalStacks";
import StacksWidget from "./Stacks";
import QuickIntervals from "./QuickIntervals";
import { useState } from "react";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
} from "../sidebar";

export default function StacksVertical() {
  const globalStacks = useGlobalStacks();
  const [recenterToken, setRecenterToken] = useState(0);

  return (
    <SidebarGroup className="h-full flex flex-column">
      <SidebarGroupLabel className="uppercase tracking-[.1em] font-bold text-[10.5px] h-auto px-[18px] pt-[15px] pb-2">
        Time
      </SidebarGroupLabel>
      <QuickIntervals
        stacks={globalStacks}
        onNavigate={() => setRecenterToken((t) => t + 1)}
      />
      {/* The level switcher moved into StacksHeader, which owns it alongside
          the From/To chips: it now re-levels the focused endpoint rather than
          the selection as a whole. The widget scrolls itself, so no wrapper
          overflow here. */}
      <SidebarGroupContent className="grow min-h-0">
        <StacksWidget stacks={globalStacks} recenterToken={recenterToken} />
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
